module.exports = __webpack_public_path__ + "img/bedrooms.0db87acb.svg";